var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-bar',{attrs:{"items":[
      { title: 'Cuentas', to: "/" },
      { title: _vm.title_page } ]}}),_c('div',{staticClass:"box"},[_c('FormCreate')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }